<template>
  <div
    v-if="imgId || srcImg"
    class="avatar-wrapper"
    :class="`tw-bg-[transparent] global-avatar tw-justify-start ${
      className || ''
    }`"
  >
    <img
      v-if="!loadingAvatar"
      alt="avatar"
      :src="img || srcImg"
      :class="imgClassName"
    />
    <div
      v-else
      class="tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] tw-w-[70px] bg-skeleton"
    ></div>
  </div>
  <div
    v-else
    :class="`tw-bg-[#211F58] global-avatar tw-justify-center tw-min-w-[70px] tw-w-[70px] tw-rounded-[5.38px] ${
      className || ''
    }`"
  >
    <p>{{ letterName }}</p>
  </div>
</template>

<script setup lang="ts">
import { getProfileImage } from "@/services/org";
import { computed, onMounted, Ref, ref, watch } from "vue";
import { getImageData } from "@/utils/utilities";

const props = defineProps<{
  srcImg?: string;
  imgId?: string;
  name?: string;
  className?: string;
  imgClassName?: string;
}>();
const img = ref<string | null>(null);
const loadingAvatar: Ref<boolean> = ref(false);

onMounted(async () => {
  if (props.imgId) {
    getAvatarImg(props.imgId);
  }
});

watch(
  () => props.imgId,
  async (value) => {
    if (value) {
      getAvatarImg(value);
    }
  },
);

const getAvatarImg = async (imgId) => {
  try {
    loadingAvatar.value = true;
    const res = await getProfileImage(imgId);
    const imageDetails = res.data.data;
    const file = await getImageData(imageDetails);
    img.value = URL.createObjectURL(file);
  } catch (error) {
    console.error("Error in fetching image", error);
  } finally {
    loadingAvatar.value = false;
  }
};

const letterName = computed(() => {
  const words = props.name?.split(" ");
  if (words?.length && words.length > 1) {
    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
  }
  return props.name?.charAt(0).toUpperCase() || "";
});
</script>

<style lang="scss" scoped>
.global-avatar {
  display: flex;
  align-items: center;
  line-height: normal;
  overflow: hidden;
  height: 70px;
  & > p {
    color: #fff;
    font-family: Poppins;
    font-size: 44px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    margin-bottom: 0px !important;
  }
  & > img {
    height: 100%;
    // border-radius: 50%;
  }
}

.bg-skeleton {
  background: linear-gradient(90deg, #f2f8ff 10%, #e9e9e9 25%, #f2f8ff 35%);
  background-size: 200% 100%;
  animation: 1.5s custom-skeleton-loading linear infinite;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .avatar-wrapper {
    height: 110px !important;
  }
}
</style>
